/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Try_ServerInputs */



/**
* | output |
* | --- |
* | "Try the Server option" |
*
* @param {Embed_Captions_Local_Try_ServerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_try_server = /** @type {((inputs?: Embed_Captions_Local_Try_ServerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Try_ServerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Essayez l'option Serveur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Probieren Sie die Serveroption.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prova l'opzione Server")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Попробуйте вариант \"Сервер\".")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pruebe la opción Servidor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("尝试服务器选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サーバーオプションをお試しください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सर्वर विकल्प आज़माएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Experimente a opção Servidor")
	return /** @type {LocalizedString} */ ("Try the Server option")
});